/**
 * Theme color-mode context (TMMAPP-0001). `themeMode` is the user's stated preference
 * (light/dark/system); `resolvedMode` is the concrete mode after resolving `system` against the
 * OS `prefers-color-scheme`.
 */
import { createContext, useContext } from 'react';
import type { ThemeMode } from '@/theme/tokens';

export type ThemeModePreference = ThemeMode | 'system';

export interface ThemeModeContextValue {
  themeMode: ThemeModePreference;
  resolvedMode: ThemeMode;
  setThemeMode: (mode: ThemeModePreference) => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  themeMode: 'system',
  resolvedMode: 'light',
  setThemeMode: () => {},
});

export function useThemeMode(): ThemeModeContextValue {
  return useContext(ThemeModeContext);
}
